
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.891 12.382H31.8v-1.935c0-1.608-1.23-2.914-2.741-2.914H18.94c-1.51 0-2.74 1.306-2.74 2.914v1.93H9.109C6.843 12.382 5 14.336 5 16.74v19.366c0 2.403 1.843 4.362 4.109 4.362H38.89c2.266 0 4.109-1.954 4.109-4.357V16.739c0-2.403-1.843-4.357-4.109-4.357zm-20.824-1.935c0-.497.39-.899.874-.899H29.06c.48 0 .874.402.874.9v1.93H18.067v-1.93zM7.37 17.277c0-1.395 1.088-2.535 2.423-2.535h28.414c1.335 0 2.423 1.136 2.423 2.536v5.61l-.247.095c-4.062 1.59-10.037 2.502-16.393 2.502-6.345 0-12.311-.908-16.373-2.493l-.247-.094v-5.62zm33.26 18.289c0 1.395-1.088 2.535-2.423 2.535H9.793c-1.335 0-2.423-1.135-2.423-2.535v-10.61l.518.18c3.577 1.243 8.374 2.038 13.514 2.237l.39.014-.02 1.017c0 .908.689 1.641 1.535 1.641h1.387c.845 0 1.534-.738 1.534-1.641v-.97l.37-.061c5.14-.199 9.942-.994 13.514-2.243l.518-.18v10.616z","fill":"#88C0B3"}})])
          )
        }
      }
    